import React, { useState, useEffect, useRef } from "react";
import Footer from "./Footer";
import Modal from "react-modal";
import axios from "axios";
import NavbarNew from "../Navbar/NavbarNew";
import Pagination from "@mui/material/Pagination";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import "./OperatorPatientFilesNew.css";
import useIdleTimer from "../../useIdleTimer";
import dateIcon from "../Operator/SVGs/sort.svg";
import Sidebar from "./components/Sidebar";
import SidebarPatient from "./components/SidebarPatient";
import questionMark from "../Images/Vector.png";
import UploadIcon from "../Images/Page-1.png";
import UploadIcon2 from "../Images/upload.png";
import UploadIcon3 from "../Images/upload_white.png";
import physician_thumbsup_image from "../Images/simple-line-icons_check.png";
import "./LoadingSpinner.css";
import { useNavigate } from "react-router-dom";
import log from "../../logger.js";
import API from "../../api";

// Modal.setAppElement('#root');

const OperatorPatientFilesNew = () => {
  const [storedUserObject, setstoredUserObject] = useState({});

  const [role, setRole] = useState("");
  // const storedUserObjectString = sessionStorage.getItem("userObject");
  // const storedUserObject = JSON.parse(storedUserObjectString);
  // const role = sessionStorage.getItem("role")
  const [isUserLoading, setIsUserLoading] = useState(true);
  const navigate = useNavigate();

  const [patient, setPatient] = useState({});
  // const [patient, setPatient] = useState(storedPatient);

  const username = storedUserObject.first_name;
  const project = sessionStorage.getItem("project");

  const [selectedFile, setSelectedFile] = useState(null);
  const [isSortedAsc, setIsSortedAsc] = useState(true);
  const [documents, setDocuments] = useState([]);
  const [error, setError] = useState(null);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  const fileInputRef = useRef(null);
  const [textColor, setTextColor] = useState("#2A6E62");
  const [backgroundColor, setBackgroundColor] = useState("#E6F6F4");
  const [icon, setIcon] = useState(UploadIcon);

  const handleMouseEnter = () => {
    setIcon(UploadIcon3);
    setTextColor("#FFFFFF");
    setBackgroundColor("#409E8D");
  };

  const handleMouseLeave = () => {
    setIcon(UploadIcon);
    setTextColor("#409E8D");
    setBackgroundColor("#C5ECE5");
  };

  const buttonStyle = {
    display: "flex",
    alignItems: "center",
    height: "40px",
    justifyContent: "center",
    width: "auto",
    minWidth: "10vw",
    padding: "1px 5px",
    fontSize: "var(--font-size-xl)",
    cursor: "pointer",
    marginLeft: "auto",
    marginRight: "0%",
    // paddingTop: "10px",
    background: backgroundColor,
    mixBlendMode: "normal",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    borderRadius: "15px",
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "2vw",
    color: textColor,
    border: "none",
    transition: "color 0.3s ease",
  };

  const iconStyle = {
    width: "2vh",
    height: "2vh",
    marginLeft: "0.5vw",
    transition: "opacity 0.3s ease",
  };

  const sort = () => {
    setIsSortedAsc(!isSortedAsc);
    const sortedDocuments = [...documents].sort((a, b) => {
      const dateA = new Date(a.upload_date);
      const dateB = new Date(b.upload_date);
      return isSortedAsc ? dateB - dateA : dateA - dateB;
    });
    setDocuments(sortedDocuments);
  };

  const fetchUserRole = async () => {
    try {
      const response = await axios.get("/common/api/get_user_role/", {
        withCredentials: true,
      });
      console.log("Fetched User Role", response.data.role);
      setRole(response.data.role);
    } catch (error) {
      console.error(
        "Error fetching user role:",
        error.response?.data || error.message
      );
    }
  };

  const fetchUser = async () => {
    try {
      const response = await axios.get("/common/api/get_user/", {
        withCredentials: true,
      });
      setstoredUserObject(response.data.user_object);
    } catch (error) {
      console.error(
        "Error fetching user:",
        error.response?.data || error.message
      );
    } finally {
      setIsUserLoading(false);
    }
  };
  const [dataFetched, setDataFetched] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      await fetchUserRole();
      await fetchUser();
      setDataFetched(true);
    };
    fetchData();
  }, []);
  const fetchPatient = async () => {
    try {
      const project = sessionStorage.getItem("project");
      const response = await API.get("/patient/get_patient_session/", {
        headers: {
          project: project,
          "Content-Type": "application/json",
        },
      });
      let rawdata = response.data.patient.replace(/'/g, '"');
      setPatient(JSON.parse(rawdata) || {});
    } catch (error) {
      log.error("Error fetching patient", {
        endpoint: "/patient/get_patient_session/",
        method: "GET",
        project: project,
        response_status: 401,
        role: role,
        error_message: "Error fetching patient",
      });
    } finally {
      setIsUserLoading(false);
    }
  };
  const handleIdle = () => {
    console.log("User is idle, logging out...");
    window.location.href = "/";
  };
  useIdleTimer(handleIdle, 1.2e6);

  // useEffect(() => {
  //   // const storedPatient = JSON.parse(sessionStorage.getItem("patient"));
  //   // if (storedPatient !== patient) {
  //   //   setPatient(storedPatient);
  //   // }
  //   if (patient) {
  //     fetchDocuments();
  //   }
  // }, [patient, currentPage, pageSize]);
  useEffect(() => {
    const fetchDocumentsOnMount = async () => {
      setLoading(true);
      try {
        if (dataFetched && patient && patient.email) {
          await fetchDocuments();
        } else {
          log.warn("Patient or patient.email is undefined", {
            endpoint: "/operator/get_all_patients/",
            method: "GET",
            project: project,
            response_status: 401,
            role: role,
          });
        }
      } catch (error) {
        console.error("Error fetching documents:", error);
      } finally {
        setLoading(false);
      }
    };
    if (patient.email) {
      fetchDocumentsOnMount();
    }
  }, [patient]);

  const fetchDocuments = async (page = currentPage, pageSize = 10) => {
    setLoading(true);
    try {
      if (!patient) {
        setError("No patient data found");
        setLoading(false);
        return;
      }
      const endpoint =
        role === "Patient"
          ? `/patient/retrieve_documents/${patient.patient_id}`
          : `/operator/retrieve_documents/${patient.patient_id}`;

      const response = await API.get(endpoint, {
        headers: {
          project,
          role,
        },
        params: {
          page,
          page_size: pageSize,
        },
      });

      if (response.status === 200) {
        log.info("Documents fetched successfully.", {
          endpoint: endpoint,
          method: "GET",
          project: project,
          response_status: response.status,
          role: role,
        });
        const { documents, total_pages } = response.data;

        const documentsWithTimestamp = documents.map((doc) => ({
          ...doc,
          date: new Date(doc.upload_date).toLocaleDateString("en-CA"),
          time: new Date(doc.upload_date).toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true, // To get AM/PM
          }),
        }));

        setDocuments(documentsWithTimestamp);
        setTotalPages(total_pages);
      } else {
        log.warn("Error fetching documents", {
          endpoint: endpoint,
          response_status: response.status,
          role: role,
          project: project,
        });
        setError("Error fetching documents");
      }
    } catch (error) {
      log.error("Error fetching documents", {
        error: error.message,
        stack: error.stack,
      });
      setError("Error fetching documents");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (role === "Patient" && storedUserObject.email) {
      setPatient(storedUserObject);
    } else {
      fetchPatient();
    }
  }, [storedUserObject]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const allowedTypes = [
      "application/pdf",
      "image/png",
      "image/jpeg",
      "image/jpg",
      "image/svg+xml",
    ];
    if (!allowedTypes.includes(file.type)) {
      setError(
        "Invalid file type. Please upload a PDF, PNG, JPEG, or SVG file."
      );
      setSelectedFile(null);
      fileInputRef.current.value = "";
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setError("File size exceeds 5MB limit.");
      return;
    }

    setSelectedFile(file);
    setError(null);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);

    const file = event.dataTransfer.files[0];
    if (!file) return;

    const allowedTypes = [
      "application/pdf",
      "image/png",
      "image/jpeg",
      "image/svg+xml",
      "application/zip",
    ];
    if (!allowedTypes.includes(file.type)) {
      alert("Invalid file type. Please upload a PDF, PNG, JPEG, or SVG file.");
      setSelectedFile(null);
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      alert("File size exceeds 5MB limit.");
      return;
    }

    setSelectedFile(file);
  };

  const uploadFile = async () => {
    if (selectedFile) {
      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("email", patient.email);
      formData.append("upload_date", new Date().toISOString());

      try {
        const headers = {
          "Content-Type": "multipart/form-data",
          project: project,
          role,
        };

        const endpoint =
          role === "Patient"
            ? `/patient/upload_document/${patient.patient_id}`
            : `/operator/upload_document/${patient.patient_id}`;

        await API.post(endpoint, formData, {
          headers,
        });
        setSelectedFile(null);
        setUploading(true);
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        const reader = new FileReader();
        reader.onprogress = (event) => {
          const { loaded, total } = event;
          const progressPercent = (loaded / total) * 100;
          setProgress(progressPercent);
        };

        reader.onload = () => {
          setTimeout(() => {
            setUploading(false);
            setProgress(0);
            setSelectedFile(null);
            setError("");
            setIsSuccessModalOpen(true);
          }, 2000);
        };
        reader.readAsDataURL(selectedFile);
        fetchDocuments();
      } catch (error) {
        setError("Error uploading file");
      } finally {
        setUploading(false);
      }
    } else {
      setError("Please select a file");
    }
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedFile(null);
  };

  const closeSuccessModal = () => {
    setIsSuccessModalOpen(false);
  };

  const handleDocumentSelect = (documentName) => {
    setSelectedDocument(documentName);
  };

  // const handleDoubleClick = (documentName) => {
  //   setSelectedDocument(documentName);
  //   downloadDocument();
  // };
  const handleDownloadClick = (documentName) => {
    setSelectedDocument(documentName); // Update selected document if needed
    downloadDocument(); // Trigger the download logic
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setCurrentPage(1);
  };

  const downloadDocument = async () => {
    const selectedDoc = documents.find((d) => d.file_name === selectedDocument);
    if (selectedDoc) {
      try {
        const endpoint =
          role === "Patient"
            ? `/patient/download_document/${selectedDoc.file_id}`
            : `/operator/download_document/${selectedDoc.file_id}`;
        const response = await API.get(endpoint, {
          headers: {
            project,
          },
          responseType: "blob",
        });
        const blob = new Blob([response.data], { type: response.data.type });
        const downloadLink = document.createElement("a");
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = selectedDoc.file_name;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      } catch (error) {
        if (error.response?.status === 401) {
          const refreshResponse = await axios.post(
            "/operator/refresh/",
            {},
            { withCredentials: true }
          );
          if (refreshResponse.status === 200) {
            sessionStorage.setItem(
              "operator_token",
              refreshResponse.data.access_token
            );
            await downloadDocument();
          } else {
            handleLogout();
          }
        } else {
          setError("Error downloading file");
        }
      }
    } else {
      setError("Please select a document");
    }
  };

  const handleLogout = async () => {
    await axios.post("/operator/logout/", {}, { withCredentials: true });
    sessionStorage.clear();
  };
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="page-body">
      {!isUserLoading && <NavbarNew username={username} />}
      <div className="page-layout">
        {role === "Patient" ? <SidebarPatient /> : <Sidebar />}
        <div className="main-content">
          <div className="patient-list-container">
            <div className="first-line-file-upload">
              <div className="title-container-file-upload">
                <h2 className="inner-page-title-file-upload">
                  {patient.first_name + "'s "} Files
                </h2>
                <div className="tooltip-container">
                  <img
                    src={questionMark}
                    alt="info-icon"
                    className="info-icon"
                  />
                  <span className="tooltip-text">View files here</span>
                </div>
              </div>

              <button
                className="add-patient-button-new"
                onClick={openModal}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                data-testid="Upload-Files"
                style={buttonStyle}
              >
                Upload
                <img
                  src={icon}
                  alt="UploadIcon"
                  className="upload-icon"
                  style={iconStyle}
                />
              </button>
            </div>
          </div>

          {/* File Upload Modal */}
          <Modal
            isOpen={isModalOpen}
            onRequestClose={closeModal}
            className="file-upload-modal"
            overlayClassName="modal-overlay"
          >
            <div className="modal-header-upload-file ">
              <h2>Upload your file</h2>
              <button className="close-button" onClick={closeModal}>
                &times;
              </button>
            </div>

            <div
              className={`upload-area ${isDragging ? "dragging" : ""}`}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
            >
              <div className="drag-drop-area">
                <img src={UploadIcon2} alt="upload" className="icon-upload" />
                <p>Drag and Drop to upload file</p>
                <p className="italic-warning">
                  (The file size should not exceed 5MB. Accepted file formats:
                  PDF, PNG, JPEG, JPG and SVG.)
                </p>
                <p>or</p>
                <label className="browse-file">
                  Browse File
                  <input
                    type="file"
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                    ref={fileInputRef}
                    data-testid="file-input"
                  />
                </label>
              </div>
            </div>

            {selectedFile && (
              <div className="file-name">{selectedFile.name}</div>
            )}
            {error && (
              <div className="error-message" data-testid="error-message">
                {error}
              </div>
            )}

            <button
              onClick={uploadFile}
              className="confirm-upload"
              disabled={uploading}
            >
              {uploading ? `Uploading... ${progress}%` : "Upload"}
            </button>
          </Modal>

          {/* Success Modal */}
          <Modal
            isOpen={isSuccessModalOpen}
            onRequestClose={closeSuccessModal}
            className="success-modal"
            overlayClassName="modal-overlay"
          >
            <div className="confirmation-modal-overlay">
              <div className="confirmation-modal-content">
                <div className="confirmation-modal-header">
                  <img
                    src={physician_thumbsup_image}
                    alt="Character"
                    className="check-image"
                  />
                </div>
                <h2>Great!</h2>
                <p>File uploaded successfully!</p>
                <button onClick={closeSuccessModal}>Okay</button>
              </div>
            </div>
          </Modal>
          {!isMobile && (
            <div
              className="scan-table-container-file-list"
              data-testid="file-list-container"
            >
              <div className="scan-table-header-file-list">
                <div className="header-cell-file-list " onClick={sort}>
                  <img
                    src={dateIcon}
                    alt="Sort Date"
                    className={`sort-icon ${isSortedAsc ? "asc" : "desc"}`}
                  />
                  Date
                </div>
                <div className="header-cell-file-list ">Time</div>
                <div className="header-cell-file-list ">File Name</div>
                <div className="header-cell-file-list ">File Type</div>
              </div>
              {loading ? (
                <div
                  className="loading-spinner-overlay"
                  data-testid="loading-spinner"
                >
                  <div className="bouncing-loader">
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              ) : documents.length === 0 ? (
                <div className={"empty-state"}>
                  <p>No file data available ..</p>
                </div>
              ) : (
                <div className={"table-body"}>
                  {documents.map((doc) => (
                    <div
                      className="user-row-table-list"
                      key={doc.file_name}
                      // onClick={() => handleDocumentSelect(doc.file_name)}
                      // onDoubleClick={() => handleDoubleClick(doc.file_name)}
                      title="Double click to download"
                    >
                      <div className="user-cell-table-list">{doc.date}</div>
                      <div className="user-cell-table-list">{doc.time}</div>
                      <div
                        className="user-cell-table-list"
                        data-testid={`file-name-${doc.file_name}`}
                      >
                        {doc.file_name}
                      </div>
                      <div className="user-cell-table-list">
                        {doc.file_type ? doc.file_type : "file"}
                      </div>
                      <div className="user-cell-table-list">
                        <button
                          className="download-button"
                          key={doc.file_name}
                          onClick={() => {
                            handleDownloadClick(doc.file_name);
                          }}
                          title="Download"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            width="16"
                            height="16"
                          >
                            <path d="M12 16c.28 0 .53-.11.71-.29l5-5a1 1 0 0 0-1.42-1.42L13 12.59V3a1 1 0 1 0-2 0v9.59L6.71 9.29a1 1 0 1 0-1.42 1.42l5 5c.18.18.43.29.71.29z" />
                            <path d="M18 18H6a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2z" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              <div className="pagination-container">
                <Stack spacing={2}>
                  <Pagination
                    count={totalPages}
                    siblingCount={0}
                    boundaryCount={1}
                    page={currentPage}
                    onChange={(event, page) => handlePageChange(page)}
                    shape="rounded"
                    showFirstButton
                    showLastButton
                    sx={{
                      "& .MuiPaginationItem-root": {
                        color: "#666666",
                        fontSize: "1vw",
                        borderRadius: "8px",
                        border: "1px solid #CCCCCC",
                      },
                      "& .Mui-selected": {
                        backgroundColor: "#66A091 !important",
                        color: "#FFFFFF !important",
                        fontSize: "1vw",
                        border: "1px solid #66A091",
                      },

                      "& .MuiPaginationItem-root:hover": {
                        backgroundColor: "#66A091",
                        color: "#FFFFFF",
                      },
                      "& .MuiPaginationItem-ellipsis": {
                        color: "#666666",
                      },
                      "& .MuiPaginationItem-icon": {
                        color: "#004C40",
                      },
                    }}
                  />
                </Stack>

                <Select
                  value={pageSize}
                  onChange={(e) => handlePageSizeChange(Number(e.target.value))}
                  variant="outlined"
                  size="small"
                  inputProps={{
                    "aria-label": "Items per page",
                  }}
                  style={{ minWidth: 60 }}
                  sx={{
                    minHeight: 3,
                    borderRadius: "10px",
                    backgroundColor: "#ffffff",
                    color: "#000000",

                    // Outline styles
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "#666666",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#000000",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#555555",
                    },

                    "& .MuiInputBase-root": {
                      fontSize: "var(--font-size-xl)",
                    },

                    ".MuiOutlinedInput-input": {
                      fontSize: "var(--font-size-xl)",
                    },

                    // This one is optional but also affects padding + font
                    ".MuiSelect-select": {
                      padding: "8px 10px",
                      fontSize: "var(--font-size-xl)",
                      color: "#666666",
                    },

                    ".MuiSelect-root": {
                      minHeight: "unset",
                    },
                  }}
                >
                  <MenuItem value={10}>10 per page</MenuItem>
                  <MenuItem value={25}>25 per page</MenuItem>
                  <MenuItem value={50}>50 per page</MenuItem>
                </Select>
              </div>
            </div>
          )}
          {isMobile && (
            <div className="user-list-cards-container">
              {documents.length === 0 ? (
                <div className={"empty-state"}>
                  <p>No file data available ..</p>
                </div>
              ) : (
                documents.map((doc, index) => {
                  return (
                    <div key={index} className="user-card file-card">
                      <div className="inner-value">
                        <p>
                          <strong>Date:</strong> {doc.date}
                        </p>{" "}
                        {/* First and Last Name on one line */}
                        <p>
                          <strong>Time:</strong> {doc.time}
                        </p>{" "}
                        {/* Email on second line */}
                        <p>
                          <strong>File Name:</strong> {doc.file_name}
                        </p>{" "}
                        <p className="indication">
                          <strong>File Type:</strong> {doc.file_type}
                        </p>{" "}
                      </div>
                      <div className="user-cell-table-list">
                        <button
                          className="download-button"
                          key={doc.file_name}
                          onClick={() => {
                            handleDownloadClick(doc.file_name);
                          }}
                          title="Download"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            width="16"
                            height="16"
                          >
                            <path d="M12 16c.28 0 .53-.11.71-.29l5-5a1 1 0 0 0-1.42-1.42L13 12.59V3a1 1 0 1 0-2 0v9.59L6.71 9.29a1 1 0 1 0-1.42 1.42l5 5c.18.18.43.29.71.29z" />
                            <path d="M18 18H6a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2z" />
                          </svg>
                        </button>
                      </div>
                      {/* USX Number and Indication on the last line */}
                    </div>
                  );
                })
              )}
              <div className="pagination-container">
                <Stack spacing={2}>
                  <Pagination
                    count={totalPages}
                    siblingCount={0}
                    boundaryCount={1}
                    page={currentPage}
                    onChange={(event, page) => handlePageChange(page)}
                    shape="rounded"
                    showFirstButton
                    showLastButton
                    sx={{
                      "& .MuiPaginationItem-root": {
                        color: "#333333",
                        fontSize: "var(--font-size-l)",
                        borderRadius: "8px",
                        border: "1px solid #CCCCCC",
                      },
                      "& .Mui-selected": {
                        backgroundColor: "#66A091 !important",
                        color: "#FFFFFF !important",
                        fontSize: "var(--font-size-l)",
                        border: "1px solid #66A091",
                      },

                      "& .MuiPaginationItem-root:hover": {
                        backgroundColor: "#66A091",
                        color: "#FFFFFF",
                      },
                      "& .MuiPaginationItem-ellipsis": {
                        color: "#666666",
                      },
                      "& .MuiPaginationItem-icon": {
                        color: "#004C40",
                      },
                    }}
                  />
                </Stack>

                <Select
                  value={pageSize}
                  onChange={(e) => handlePageSizeChange(Number(e.target.value))}
                  variant="outlined"
                  size="small"
                  inputProps={{
                    "aria-label": "Items per page",
                  }}
                  style={{ minWidth: 60 }}
                  sx={{
                    minHeight: 3,
                    borderRadius: "10px",
                    backgroundColor: "#ffffff",
                    color: "#000000",
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: "#333333",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#000000",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#555555",
                    },
                    ".MuiSelect-select": {
                      padding: "8px 10px",
                      fontSize: "var(--font-size-l)",
                      color: "#000000",
                    },
                    ".MuiSelect-root": {
                      minHeight: "unset",
                    },
                  }}
                >
                  <MenuItem value={10}>10 per page</MenuItem>
                  <MenuItem value={25}>25 per page</MenuItem>
                  <MenuItem value={50}>50 per page</MenuItem>
                </Select>
              </div>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default OperatorPatientFilesNew;
